import { render, staticRenderFns } from "./ActivityView.vue?vue&type=template&id=3b676678&scoped=true&"
import script from "./ActivityView.vue?vue&type=script&lang=ts&"
export * from "./ActivityView.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityView.vue?vue&type=style&index=0&id=3b676678&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b676678",
  null
  
)

export default component.exports